'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zfc on 2016/9/17.
 */

var GongmeiEncyclopediaComponent = function (_Component) {
  (0, _inherits3.default)(GongmeiEncyclopediaComponent, _Component);

  function GongmeiEncyclopediaComponent() {
    (0, _classCallCheck3.default)(this, GongmeiEncyclopediaComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GongmeiEncyclopediaComponent).apply(this, arguments));
  }

  (0, _createClass3.default)(GongmeiEncyclopediaComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./GongmeiEncyclopediaComponent.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.gon },
        _react2.default.createElement(
          'div',
          { className: styles.gotie },
          _react2.default.createElement('div', { className: styles.line }),
          _react2.default.createElement(
            'div',
            { className: styles.log },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/gonbg.png',
                alt: '' })
            )
          ),
          _react2.default.createElement('div', { className: styles.line + ' ' + styles.ml23 })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.henga },
          _react2.default.createElement(
            'div',
            { className: styles.bp },
            _react2.default.createElement('img', { className: styles.find, src: 'http://tupian.goeasy.cn:9999/yipinwang/find.png', alt: '' }),
            _react2.default.createElement('input', { type: 'text', className: styles.input })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.hengaBtn },
            '搜索'
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: styles.klo },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              null,
              _react2.default.createElement('img', { src: '', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: styles.txt },
                _react2.default.createElement(
                  'div',
                  { className: styles.tti },
                  '雕刻知识'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.txx },
                  '创造出具有一定空间的可视.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'li',
            { style: { marginLeft: '9px' } },
            _react2.default.createElement(
              'a',
              null,
              _react2.default.createElement('img', { src: '', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: styles.txt },
                _react2.default.createElement(
                  'div',
                  { className: styles.tti },
                  '雕刻知识'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.txx },
                  '创造出具有一定空间的可视.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'li',
            { style: { marginLeft: '8px' } },
            _react2.default.createElement(
              'a',
              null,
              _react2.default.createElement('img', { src: '', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: styles.txt },
                _react2.default.createElement(
                  'div',
                  { className: styles.tti },
                  '雕刻知识'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.txx },
                  '创造出具有一定空间的可视.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '', className: styles.butgo },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/nowbg11.jpg',
            alt: '' })
        )
      );
    }
  }]);
  return GongmeiEncyclopediaComponent;
}(_react.Component);

exports.default = GongmeiEncyclopediaComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GongmeiEncyclopediaComponent/GongmeiEncyclopediaComponent.js
 ** module id = 1349
 ** module chunks = 0
 **/